import { cond, stubTrue, get } from 'lodash-es'
import styled from '@emotion/styled'

const SVG = styled.svg`
  ${({ theme, primary, error, white, textSecondary, $ptr, $color }) => `
    fill: ${cond([
      [(props) => props.error, () => theme.palette.error.main],
      [(props) => props.primary, () => theme.palette.primary.main],
      [(props) => props.white, () => theme.palette.primary.contrastText],
      [(props) => props.textSecondary, () => theme.palette.text.secondary],
      [(props) => !!props.$color, () => get(theme.palette, $color)],
      [stubTrue, () => theme.palette.text.primary],
    ])({ primary, error, white, textSecondary, $color })};
    ${$ptr ? 'cursor: pointer;' : ''}
  `}
`

export default SVG
